const groupBy = (xs, key) => {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

const splitByHead = (irrigationInstructions) => {
  return Object.values(groupBy(irrigationInstructions, "head"));
};

export default splitByHead;
